import { delete_, get, post, put } from ".";

export const getAdmins = (filter) => {
  return get(`/api/admin/user/list${filter||""}`, true);
};

export const changeStatus = (userId, status) => {
  return put(`/api/admin/user/changeStatus/${userId}/${status}`, true);
};
export const changeStatusGroup = (groupId) => {
  return put(`/api/admin/group/toggleActivityStatus/${groupId}`, true);
};

export const changeOwner = (groupId, userId) => {
  return put(`/api/admin/group/setNewOwner/${groupId}/${userId}`, true);
};
export const loginAdminToUser = (data) => {
  return post(`/api/admin/user/signIn`, true,data);
};
export const deleteUser = (userId) => {
  return delete_(`/api/admin/user/remove/${userId}`, true);
};

